import {
    Component, OnInit, Input, ElementRef, HostBinding, Optional,
    Renderer2, HostListener, ViewEncapsulation
} from '@angular/core';

import { MenuComponent, PADDING_BASE } from './menu.component';
import { SubMenuComponent } from './submenu.component';

@Component({
    selector: '[jui-menu-item]',
    template: `
        <ng-content></ng-content>
    `,
    encapsulation: ViewEncapsulation.None
})

export class MenuItemComponent implements OnInit {
    hostEl: HTMLElement;
    level = 0;
    padding = null;
    _selected = false;

    @Input() disabled = false;
    @Input()
    get selected(): boolean {
        return this._selected;
    }
    set selected(value: boolean) {
        this._selected = value;
        if (value) {
            this.renderer2.addClass(this.hostEl, 'jui-menu-item-selected');
        } else {
            this.renderer2.removeClass(this.hostEl, 'jui-menu-item-selected');
        }
    }

    @HostBinding('class.jui-menu-item')
    get setItemClass() {
        return true;
    }
    @HostBinding('class.jui-menu-item-disabled')
    get setMenuDisableClass() {
        return this.disabled;
    }
    @HostBinding('style.padding-left.px')
    get setPaddingLeft() {
        if (this.subMenuComponent) {
            if (this.subMenuComponent.menuComponent.mode === 'inline') {
                return (this.subMenuComponent.level + 1) * PADDING_BASE;
            } else {
                return this.padding;
            }
        } else if (this.menuComponent.hasSubMenu && (this.menuComponent.mode === 'inline')) {
            return PADDING_BASE;
        } else {
            return this.padding;
        }
    }

    constructor(
        private elementRef: ElementRef,
        private renderer2: Renderer2,
        public menuComponent: MenuComponent,
        @Optional() public subMenuComponent: SubMenuComponent
    ) {
        this.menuComponent.menuItems.push(this);
        this.hostEl = this.elementRef.nativeElement;
        if (this.hostEl.style['padding-left']) {
            this.padding = parseInt(this.hostEl.style['padding-left'], 10);
        }
    }

    @HostListener('click', ['$event'])
    onClickItem(event) {
        if (!this.disabled) {
            this.menuComponent.clearAllSelected();
            this.selected = true;
        }
    }

    ngOnInit() { }
}
